import styled from "styled-components";
import {baseDistance, VerticalFlexStyle} from "../../../../../../styles/styles";
import {colorPalette} from "../../../../../../styles/colorPalette";
import {TabViewStyled} from "../../../../../../widgets/tab/TabView.styled";
import {TabChildStyled} from "../../../../../../abstract/table/TabChildV5";
import {TabViewButtonContainerStyled, TabViewActionBarStyled} from "../../../../../../widgets/tab/TabViewV5";
import {ToggleButton} from "../../../../../../widgets/ToggleButton.styled";

export const ReportFilterStyled = styled.div`
	${VerticalFlexStyle};

	${TabViewStyled} {
		${VerticalFlexStyle};
		min-height: 0;

		${TabViewButtonContainerStyled} {
			padding: 0;

			${TabViewActionBarStyled} {
				gap: 40px;
			}

			${ToggleButton} {
				&:hover {
					color: inherit;
				}

				.tabLabel {
					padding: ${baseDistance.sm};
					border-bottom: solid 2px ${colorPalette.primary.c500Primary};

					&:hover {
						color: inherit;
					}
				}

				&:not(.selected) {
					.tabLabel {
						border-bottom-color: transparent;
					}
				}

				&.selected {
					&:hover {
						color: ${colorPalette.primary.c500Primary};
					}
				}
			}
		}

		.views {
			display: flex;
			min-height: 0;

			${TabChildStyled} {
				min-height: 0;

				.ReportFilterContainer {
					display: flex;
					min-height: 0;
				}
			}
		}
	}
`;
